import { useState, useEffect, useRef } from "react";
import seriesStore from "../stores/seriesStore.js";
import gameResultStore from "../stores/gameResultStore.js";
import Footer from "../components/Footer.js";
import { useNavigate } from "react-router-dom";

export default function GamePage() {

    const navigate = useNavigate();
    const serStore = seriesStore();   
    const gameResStore = gameResultStore();

    const [selectedShow, setSelectedShow] = useState(null);
    const [selectedSeriesList, setSelectedSeriesList] = useState(null);
    const [activeHeader, setActiveHeader] = useState(false);

    const [query, setQuery] = useState("");
    const [guessedShows, setGuessedShows] = useState([]);

    const [gameResult, setGameResult] = useState(null); 
    const [hasPlayedToday, setHasPlayedToday] = useState(false); 
    const [showResultPopup, setShowResultPopup] = useState(false);

    const [showLeaderboard, setShowLeaderboard] = useState(false);
    const [leaderboard, setLeaderboard] = useState(null); 

    // Mobile overlay
    const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
   
    // Runs the function on load
    useEffect(() => {
        serStore.fetchSeries();
    }, []);

    // Check if user has played today
    useEffect(() => {
        const fetchData = async () => {
            console.log("GamePage test");
            const results = await gameResStore.fetchGameResults(); 
            console.log("results: ", results);

            const todayKey = new Intl.DateTimeFormat("en-CA", {
                timeZone: "America/New_York",
                year: "numeric",
                month: "2-digit",
                day: "2-digit"
            }).format(new Date());

            // Check if user played today. If they did, get their results + guessedShows
            const game = results.find(r => r.dayKey === todayKey);
            setHasPlayedToday(!!game);
            
            if (game) {
                setGuessedShows(game.guessedShows || []);   

                // Add the show of the day
                setGuessedShows(prev => {  
                    const updated = [...prev, showOfTheDay];
                    return updated;
                });

                // Show leaderboard
                await fetchDayTop10();
                setShowLeaderboard(true);
            }
        };

        fetchData();
    }, []);


    // Get the show of the day 
    const dayKey = new Intl.DateTimeFormat("en-CA", {
        timeZone: "America/New_York", // go birds
        year: "numeric",
        month: "2-digit",
        day: "2-digit"
    }).format(new Date());
    function hashString(str) {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        return Math.abs(hash);
    };
    const index = hashString(dayKey) % serStore.series?.length;
    const showOfTheDay = serStore.series?.[index];

    const filteredSeries = serStore.series?.filter((s) =>
        s.title.toLowerCase().includes(query.toLowerCase())
    );

    // Comparison helper function:
    const getCategoryColor = (category, guessValue, actualValue) => {
        if (!guessValue || !actualValue) return "#202020";

        // if it's an array (like genres)
        if (Array.isArray(guessValue) && Array.isArray(actualValue)) {
            const match = guessValue.some(g => actualValue.includes(g));
            return match ? "#4caf50" : "#202020"; 
        }

        // otherwise
        if (category === "seasons") {
            if (guessValue === actualValue) return "#4caf50";
            if (Math.abs(guessValue - actualValue) <= 3) return "#afaa4c";
            return  "#202020";
        } else if (category === "year") {
        if (guessValue === actualValue) return "#4caf50";
            if (Math.abs(guessValue - actualValue) <= 5) return "#afaa4c";
            return "#202020";
        }

        return guessValue === actualValue ? "#4caf50" : "#202020";
    };

    const checkForHyphen = (category, guessValue, actualValue) => {
        const num = category === "season" ? 3 : category === "year" ? 5 : 0;

        if (Math.abs(guessValue - actualValue) <= num && guessValue > actualValue)
            return <img src="/assets/icons/chevron-down-white.png" className="gpHintIcon"/>;
        else if (Math.abs(guessValue - actualValue) <= num && actualValue > guessValue)
            return <img src="/assets/icons/chevron-up-white.png" className="gpHintIcon"/>;
    };

    const checkGameStatus = (currentGuesses) => {
        const currentGuess = currentGuesses?.length; 
       
        // check if they won
        if (currentGuesses[currentGuess-1]?._id === showOfTheDay?._id) {     
            endGame("won", currentGuess);
        }

        // check if they lost
        if (currentGuess == 10) {   
            setGuessedShows(prev => [...prev, showOfTheDay]);
            endGame("lost", 11);
        }
    };

    const endGame = async (result, numGuesses) => {
        setGameResult(result);
        setShowResultPopup(true);

        await gameResStore.createGameResult(numGuesses, guessedShows);
        
        await fetchDayTop10();
        setShowLeaderboard(true);
        setHasPlayedToday(true);
    };

     const fetchDayTop10 = async() => {
        try {
            const leaderboard = await gameResStore.fetchDayTop10();
            setLeaderboard(leaderboard);
        } catch (err) {
            console.error("Failed to fetch leaderboard:", err);
            return [];
        }
    };
    

    return (
        <div className="app-wrapper tv-static">
            <header class="gpHeader">
                <div>
                    <h1 className="scopedLogo" onClick={() => {
                        setSelectedShow(null);
                        setSelectedSeriesList(null);
                        setActiveHeader(null);
                        navigate("/");
                    }}>ScopedTV</h1>
                </div>
            </header>
            <div className="gpContent">
                <div className="gamePage">
                    <div>
                        <div> 
                            <h3>Show of the Day</h3>
                        </div>
                        <div>
                            {showLeaderboard && <div>
                                <h4>Today’s Leaderboard</h4>
                                <ol className="showOfTheDayLeaderboard">
                                    {leaderboard?.map((u, i) => (
                                        <li key={i}>
                                            <span>{u.name}</span>
                                            <span>{u.numGuesses}</span>
                                        </li>
                                    ))}
                                </ol>
                            </div>
                            }
                            {(!hasPlayedToday) && (<div> 
                                <p>Guesses: {guessedShows?.length || 0} / 10</p>
                                <div className="gpSearchBar">
                                <input
                                    type="text"
                                    placeholder="search"
                                    value={query}
                                    onFocus={() => setMobileSearchOpen(true)}
                                    onChange={(e) => setQuery(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter" && filteredSeries?.length > 0) {
                                            setGuessedShows(prev => {
                                                const updated = [...prev, filteredSeries[0]];
                                                checkGameStatus(updated);
                                                return updated;
                                            });
                                            setQuery("");
                                            setMobileSearchOpen(false);
                                        }
                                    }}
                                />
                            </div></div>)}
                            {mobileSearchOpen && (
                            <div className="gpSearchResults">
                                {filteredSeries?.map((s) => (
                                <div
                                    key={s._id}
                                    className="gpSearchResultItem"
                                    onClick={() => {
                                    setGuessedShows(prev => {
                                        const updated = [...prev, s];
                                        checkGameStatus(updated);
                                        return updated;
                                    });
                                    setQuery("");
                                    setMobileSearchOpen(false);
                                    }}
                                >
                                    {s.title}
                                </div>
                                ))}
                            </div> 
                            )}

                        </div>
                            
                            <div>
                                {guessedShows?.slice().reverse().map((s) => (
                                    <div class="gpGuessedShow">
                                        <div className="gpSeriesImage" 
                                            style={{
                                                backgroundImage: `url('${s?.fanart}')`,
                                            }}>
                                        </div>
                                        <div className="gpTitle">{s.title}</div>
                                        <div class="gpRow1">
                                            <div className="gpCategoryBlock" style={{
                                                backgroundColor: getCategoryColor("genre", s.genres, showOfTheDay.genres)
                                            }}>
                                                <p className="gpCategoryTitle">Genre</p>
                                               <div className="genreText">
                                                    {s.genres?.join(", ")}
                                                </div>
                                            </div>
                                            <div className="gpCategoryBlock" style={{
                                                backgroundColor: getCategoryColor("seasons", s.numberOfSeasons, showOfTheDay.numberOfSeasons)
                                            }}>
                                                <p className="gpCategoryTitle">Seasons</p>
                                                <span>{s.numberOfSeasons}{" "}
                                                {checkForHyphen(
                                                "season",
                                                s.numberOfSeasons,
                                                showOfTheDay.numberOfSeasons
                                                )}</span>
                                            </div>
                                            <div className="gpCategoryBlock" style={{
                                                backgroundColor: getCategoryColor("language", s.originalLanguage, showOfTheDay.originalLanguage)
                                            }}>
                                                <p className="gpCategoryTitle">Language</p>
                                                {s.originalLanguage}
                                            </div>
                                        </div>
                                        <div class="gpRow2">
                                            <div className="gpCategoryBlock" style={{
                                                backgroundColor: getCategoryColor("year", s.year, showOfTheDay.year)
                                            }}>
                                                <p className="gpCategoryTitle">Year</p>
                                                <span>{s.year}{" "}
                                                {checkForHyphen(
                                                "year",
                                                s.year,
                                                showOfTheDay.year
                                                )}</span>
                                            </div>
                                            <div className="gpCategoryBlock" style={{
                                                backgroundColor: getCategoryColor("network", s.network, showOfTheDay.network)
                                            }}>
                                                <p className="gpCategoryTitle">Network</p>
                                                {s.network}
                                            </div>
                                            <div className="gpCategoryBlock" style={{
                                                backgroundColor: getCategoryColor("status", s.airingStatus, showOfTheDay.airingStatus)
                                            }}>
                                                <p className="gpCategoryTitle">Status</p>
                                                {s.airingStatus}
                                            </div>
                                        </div>
                                    </div> 
                                ))}   
                          </div>
                    </div>
                 </div>
            </div>

            <footer class="footer"><Footer></Footer></footer>
            {showResultPopup && (<div className="popup-overlay" onClick={() => setShowResultPopup(false)}>
                <div className="popup-content">
                    {gameResult === "won" && ( <p className="gpResultMessage">You won! 🎉</p> )}
                    {gameResult === "lost" && ( <p className="gpResultMessage">Game Over 😧</p> )}
                    <p>The show of the day is..</p>
                    <div className="gpResultDiv" onClick={() => {
                            navigate("/series", { state: {
                                    selectedShow: showOfTheDay,
                                    selectedSeriesList: null,
                                    activeHeader: showOfTheDay._id
                                }  });
                            setShowResultPopup(false);
                        }}>
                        <div>
                            <div className="gpResultTitle">{showOfTheDay?.title}</div>
                            <div className="gpSeriesImage" 
                                style={{
                                    backgroundImage: `url('${showOfTheDay?.fanart}')`,
                                }}>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
        </div>
    )
}